<h1 mat-dialog-title>Arbeitsbericht</h1>
<div mat-dialog-content>
  <app-form-arbeitsbericht
    [form]="form"
    [anlagenreihe]="auftrag.ANLAGENREIHE"
  ></app-form-arbeitsbericht>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]>Abbrechen</button>
  <button mat-button [mat-dialog-close]="form.dirty ? form.value : null" cdkFocusInitial>
    Speichern
  </button>
</div>
